import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "3649702F-70B9-4383-876D-0AB14A665349"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Mok\\u0117jimo-atlikti-nepavyko",
			transform: "translate(-485.000000, -246.000000)",
			fill: "#F35B69",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "error",
				transform: "translate(485.000000, 246.000000)",
				children: [/* @__PURE__ */ _jsxs("g", {
					id: "Group",
					transform: "translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) translate(7.000000, 7.000000)",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle",
						style: { mixBlendMode: "multiply" },
						x: -145519152e-19,
						y: 4,
						width: 10,
						height: 2,
						rx: .6
					}), /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle",
						style: { mixBlendMode: "multiply" },
						x: 4,
						y: -261479727e-20,
						width: 2,
						height: 10,
						rx: .6
					})]
				}), /* @__PURE__ */ _jsx("path", {
					d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z",
					id: "Oval",
					fillRule: "nonzero"
				})]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgErrorCircle);
export default ForwardRef;
